// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-letter-template-js": () => import("../src/templates/letterTemplate.js" /* webpackChunkName: "component---src-templates-letter-template-js" */),
  "component---src-pages-404-js": () => import("../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-index-js": () => import("../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

